<template>
  <div id="app" class="app" @wheel="onWheel">
    <Header v-cloak />

    <Wrapper v-cloak>
      <!-- <preloader /> -->
      <transition :name="transitionName">
        <router-view class="view" />
      </transition>
    </Wrapper>

    <Aside v-cloak :isScrolled="!isNewPage"></Aside>
    <AsideSecond v-cloak :isScrolled="!isNewPage"></AsideSecond>

    <svg-sprite></svg-sprite>
  </div>
</template>

<script>
import SvgSprite from '@/components/common/SvgSprite'
import Header from '@/components/common/Header'
import Wrapper from '@/components/common/Wrapper'
import Aside from '@/components/common/Aside'
import AsideSecond from '@/components/common/Aside2'
// import Preloader from "@/components/common/Preloader";
// import VueCookies from 'vue-cookies';
// import Vue from 'vue';
import { maxWidth, watchMaxWidth, sassVariables } from '@/utils'
import { getMetaInfo } from '@/seo'
import { sanitizeQuery } from '@/utils/query'

// Vue.use(VueCookies, { expire: '30d' })

export default {
  name: 'App',

  components: {
    SvgSprite,
    Header,
    Wrapper,
    Aside,
    AsideSecond
    // Preloader,
  },

  data (vm) {
    return {
      isMobile: maxWidth(sassVariables['mobile']),
      unwatchMaxWidth: watchMaxWidth(sassVariables['mobile'], ({ matches }) => {
        vm.isMobile = matches
      }),
      transitionName: 'fade-out',
      isNewPage: true
    }
  },

  metaInfo () {
    return getMetaInfo(this.$route.path)
  },

  mounted () {
    // this.initScipt();

    if (document.readyState === 'complete') {
      this.onWindowLoad()
    } else {
      window.addEventListener('load', this.onWindowLoad, { once: true })
    }

    this.$router.onReady(() => {
      this.getUtm()
    })
  },

  updated () {
    const home = this.$route.fullPath === '/'
    this.transitionName = home ? 'fade-instant' : 'fade-out'
  },

  beforeDestroy () {
    window.removeEventListener('load', this.onWindowLoad)
    this.unwatchMaxWidth()
  },

  methods: {
    onWindowLoad () {
      this.$store.dispatch('ui/setLoadState', true)
      const userId = localStorage.getItem('user_id') || ''
      DSPCounter('send', {
        'sid': '230574',
        'user_id': userId
      })
    },
    onWheel (event) {
      if (this.isNewPage && event.deltaY > 50) {
        this.isNewPage = false
      }
    },
    getUtm () {
      const query = sanitizeQuery(this.$route.query)
      if (Object.keys(query).length > 0) {
        try {
          localStorage.setItem('utm_mas', JSON.stringify(query))
        } catch (error) { /* Navigation still works with storage disabled. */ }
        // this.$cookies.set('utm_mas', query);
      }
    },
    initScipt () {
      const s = document.createElement('script')
      s.innerHTML = `
          (function(a,_,o,c,r,m) {
            a[m]={id:"243597",
            hash:"05096a5b76823fcc08e99c96d3f86a5d8e771257d3fa318dc8badaeb57ae7908",
            locale:"ru", inline:true, setMeta: function(p) {
              this.params=(this.params||[]).concat([p])}};a[o]=a[o]||function() {
                (a[o].q=a[o].q||[]).push(arguments)
              };
              var d=a.document, s=d.createElement('script');
              s.async=true; s.id=m+'_script';
              s.src='https://gso.amocrm.ru/js/button.js?1658763398';
              d.head&&d.head.appendChild(s)
            }(window,0,'amoSocialButton',0,0,'amo_social_button')
          );
      `
      document.body.appendChild(s)

      window.amoSocialButtonConfig = {
        hidden: false
      }
    }
  },

  watch: {
    '$route.path' () {
      this.isNewPage = true
    }
  }
}
</script>

<style lang="scss">
video {
  object-fit: cover;
  font-family: "object-fit: cover;";
}

html,
body {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-size-adjust: none;
  @include font-base;
  color: #000;
  background: #fff;
  min-height: 100%;
  min-width: 320px;
  font-size: vw(18);
  line-height: 1.2;
  scroll-behavior: auto !important;
  -webkit-overflow-scrolling: touch;
}

.app {
  min-height: 100vh;
  position: relative;
  padding-top: $header-height;

  @include max-width(mobile) {
    padding-top: $header-mob;
  }

  padding-left: $aside-width;

  @include max-width(mobile) {
    padding-left: 0;
  }
}

::selection {
  color: #fff;
  background: #000;
}

.fade-out-leave-active {
  transition: opacity 0.25s ease-out;
}

.fade-out-leave-to {
  opacity: 0;
}

.fade-instant-leave-active {
  transition: opacity 0s ease-out;
}

.fade-instant-leave-to {
  opacity: 0;
}

.view-home {
  @at-root .fp-enabled & {
    height: calc(100vh - #{$header-height});
  }
}

.fullpage-wrapper {
  height: 100%;
  transform: translate3d(0, 0, 0);
}

.full-section {
  color: #fff;
  position: relative;

  &__main {
    height: calc(100vh - #{$header-height});
  }

  @include max-width(mobile) {
    &__main {
      min-height: calc(100vh - #{$header-mob});
    }
    height: auto;
  }

  @at-root .fp-enabled & {
    height: 100%;

    @include min-width(tablet) {
      pointer-events: none;
    }

    @include max-width(xs) {
      .full-section__container {
        color: transparent;
        transition: color 0.5s $cubic-basic 0s;
      }
    }
  }

  @at-root .fp-destroyed & {
    pointer-events: auto;

    @include max-width(xs) {
      .full-section__container {
        color: inherit;
      }
    }
  }

  @at-root .fp-enabled &.fp-completely {
    pointer-events: auto;
  }

  @at-root .fp-enabled &.active {
    @include max-width(xs) {
      .full-section__container {
        color: inherit;
      }
    }
  }

  &__container {
    position: relative;
    height: 100%;
    display: flex;
  }

  &__background {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: 1;
    overflow: hidden;
  }

  &__foreground {
    margin-top: auto;
    position: relative;
    will-change: transform, opacity;
    transform: translate3d(0, 0, 0);
    z-index: 2;
    padding: 0 0 vw(110) vw(125);

    @include max-width(mobile) {
      padding-left: vwm(18);
      padding-bottom: vwm(158);
    }
  }

  &__subtitle {
    @include section-subtitle;
  }

  &__title {
    @include section-title;
  }

  &__desc {
    @include section-desc;
  }

  &__video {
    width: 100%;
    height: 100%;
    display: block;
    position: absolute;
    object-fit: cover;
    max-width: fit-content;
    max-width: none;
    object-position: center center;
    @include no-interaction;

    &-container {
      position: relative;
      width: 100%;
      height: 100%;
    }
  }
}

.fp-scrollable {
  max-height: 100%;
}

/* IE FIXES */
.full-section__container {
  width: 100%;
}

.full-section__foreground {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
}

.fp-auto-height {
  height: auto;
}

@supports (display: flex) {
  .full-section__foreground {
    position: relative;
    bottom: auto;
    left: auto;
    right: auto;
  }
}

.breadcrumbs {
  font-size: 0;
  opacity: 0;
  z-index: -99;
  color: transparent;
  user-select: none;
  height: 0;
  width: 0;
  position: absolute;
}

</style>
